// extracted by mini-css-extract-plugin
module.exports = {"metadataPackageTitle":"styles_metadataPackageTitle__JYc2l"};